// Copyright 2026. WebPros International GmbH. All rights reserved.

export const STORE_PERSIST_KEY = 'root';
export const AUTH_PERSIST_KEY = 'auth';
